import * as React from 'react';
import { NavLink, useNavigate, } from "react-router-dom-v5-compat";

import { ProgressReportsSidebar, SMALL_ICON_BASE_SRC } from '../../../../Shared/index'

const standardsIconSrc = `${SMALL_ICON_BASE_SRC}/standards.svg`
const accountIconSrc = `${SMALL_ICON_BASE_SRC}/account.svg`

const Sidebar = ({
  classrooms,
  closeMobileSidebar,
  showMobileSidebar,
  showSidebarButton,
  selectedClassroomId,
  setSelectedClassroom
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!selectedClassroomId) { return }

    const updatedPath = location.pathname.replace(
      /\/classroom\/\d+/,
      `/classroom/${selectedClassroomId}`
    );

    navigate(updatedPath);
  }, [selectedClassroomId])

  const classroomOptions = classrooms.map(classroom => ({ ...classroom, value: classroom.id, label: classroom.name, }))
  const selectedClassroomOption = classroomOptions.find(opt => opt.value === selectedClassroomId);

  const baseLink = `/teachers/progress_reports/standards_report/classroom/${selectedClassroomId}`

  const activeClassName = ({ isActive }) => (isActive ? 'active focus-on-light' : 'focus-on-light');

  return (
    <ProgressReportsSidebar
      ariaLabel="Standards Report Navigation"
      classroomOptions={classroomOptions}
      closeMobileSidebar={closeMobileSidebar}
      onClassroomChange={setSelectedClassroom}
      selectedClassroom={selectedClassroomOption}
      showMobileSidebar={showMobileSidebar}
      showSidebarButton={showSidebarButton}
    >
      <div className="sidebar-section">
        <nav aria-labelledby="smartGroupsTitle">
          <h2 id="smartGroupsTitle">Smart Groups</h2>
          <NavLink className={activeClassName} to={`${baseLink}/smart_groups/by_standard`}><img alt="" src={standardsIconSrc} />By Standard</NavLink>
          <NavLink className={activeClassName} to={`${baseLink}/smart_groups/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
        </nav>
      </div>
      <div className="sidebar-section">
        <nav aria-labelledby="performanceBreakdownTitle">
          <h2 id="performanceBreakdownTitle">Performance Breakdown</h2>
          <NavLink className={activeClassName} to={`${baseLink}/performance_breakdown/by_standard`}><img alt="" src={standardsIconSrc} />By Standard</NavLink>
          <NavLink className={activeClassName} to={`${baseLink}/performance_breakdown/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
        </nav>
      </div>
    </ProgressReportsSidebar>
  )
}

export default Sidebar
